/**
 * Created by eliranm on 10/11/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var LocaleResolver = require('i18n/localeResolver');
    var DomUtilities = require('infra-util/DomUtilities');
    var Bubble = require('ui/bubble/Bubble');
    var template = require("content-templates/content-import-errors/contentImportErrorsTableRowView.tmpl");
    var Config = require('content-config/contentImportErrorsConfig.json');
    var PlusCompositeView = require('ui/plus-composite-view/PlusCompositeView');
    var cannedMessageConfig = require("content-config/cannedMessageConfig.json");

    var ContentImportErrorsTableRowView = {};
    var ERROR_CODE_LOB_NOT_EXIST = 235;
    var ERROR_CODE_SKILL_NOT_EXIST = 234;
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportErrorsTableRowView = Marionette.ItemView.extend({
            template: template,
            tagName: 'tr',
            className: 'content-import-errors-row',
            withUIComponents: true,

            events: {
                'mouseenter td.errors .errors-icon': '_showErrorsBubble',
                'mouseleave td.errors .errors-icon': '_hideErrorsBubble'
            },

            ui: {
                itemId: '.item-id',
                language: '.language',
                languageBoxContainer: '.language-box-container',
                title: '.title',
                text: '.text',
                categories: '.categories',
                categoriesBoxContainer: '.categories-box-container',
                status: '.status',
                LOBs: '.LOBs',
                LOBsBoxContainer: '.LOBs-box-container',
                skills: '.skills',
                skillsBoxContainer: '.skills-box-container',
                hotKeyLetter: '.hot-key-letter',
                hotKeyNumber: '.hot-key-number'
            },

            bubbles: {},

            initialize: function () {
                this.categoriesValidators = LE.crossModule('manager', LE.media.actions.request, LE.mediaCodes.manager.reqres.getCategoriesValidators);
            },

            onRender: function () {
                this._render(this.model.getItemId(), this.ui.itemId);
                this._render(this.model.getLanguage(), this.ui.language);
                this._render(this.model.getTitle(), this.ui.title);
                this._render(this.model.getText(), this.ui.text);
                this._render(this.model.getCategories(), this.ui.categories);
                if(LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    this._render(this.model.getLOBs(), this.ui.LOBs);
                    this.ui.LOBs.removeClass("hide");
                }
                this._render(this.model.getSkills(), this.ui.skills);
                this._render(this.model.getStatus(), this.ui.status);
                this._render(this.model.getHotKeyLetter(), this.ui.hotKeyLetter);
                this._render(this.model.getHotKeyNumber(), this.ui.hotKeyNumber);
            },

            templateHelpers: function () {
                return {
                    itemIdValue: this.model.getItemId().value,
                    titleValue: this.model.getTitle().value,
                    textValue: this.model.getText().value,
                    statusValue: this.model.getStatus().value,
                    hotKeyLetterValue: this.model.getHotKeyLetter().value,
                    hotKeyNumberValue: this.model.getHotKeyNumber().value
                };
            },

            _render: function (modelAttr, uiBinding) {
                this._renderBoxes(modelAttr, uiBinding);
                this._renderErrors(modelAttr, uiBinding);
            },

            _renderBoxes: function (modelAttr, uiBinding) {
                var options,
                    isLanguageUiBinding = uiBinding === this.ui.language,
                    isCategoriesUiBinding = uiBinding === this.ui.categories,
                    isLOBsUiBinding = uiBinding === this.ui.LOBs,
                    isSkillsUiBinding = uiBinding === this.ui.skills;

                if (!isLanguageUiBinding && !isCategoriesUiBinding && !isSkillsUiBinding && !isLOBsUiBinding || !modelAttr.value) {
                    return;
                }

                if (isLanguageUiBinding) {
                    options = this._getLanguageBoxOptions();
                } else if (isCategoriesUiBinding) {
                    options = this._getCategoriesBoxOptions();
                } else if (isLOBsUiBinding) {
                    options = this._getLOBsBoxOptions();
                } else if (isSkillsUiBinding) {
                    options = this._getSkillsBoxOptions();
                }
                this.uiComponents.host$.createAndRender(this._createBoxUid(), {
                    type: PlusCompositeView,
                    options: _.extend({
                        visibleItemsCount: 1,
                        itemView: PlusCompositeView.DefaultPlusComponentItemView,
                        escapeHtml: false
                    }, options)
                });
            },

            _getLanguageBoxOptions: function () {
                return {
                    el: 'view.ui.languageBoxContainer',
                    collection: 'view._getLanguagePlusCompositeViewCollection'
                };
            },

            _getCategoriesBoxOptions: function () {
                return {
                    el: 'view.ui.categoriesBoxContainer',
                    collection: 'view._getCategoriesPlusCompositeViewCollection'
                };
            },

            _getLOBsBoxOptions: function () {
                return {
                    el: 'view.ui.LOBsBoxContainer',
                    collection: 'view._getLOBsPlusCompositeViewCollection'
                };
            },

            _getSkillsBoxOptions: function () {
                return {
                    el: 'view.ui.skillsBoxContainer',
                    collection: 'view._getSkillsPlusCompositeViewCollection'
                };
            },

            _renderErrors: function (modelAttr, uiBinding) {
                if (modelAttr.errors) {
                    uiBinding.addClass(Config.css.errors);
                    $('<span>').addClass(Config.css.errorsIcon).prependTo(uiBinding);
                }
            },

            _createUid: function () {
                return Math.floor(Math.random() * Date.now());
            },

            _createBubbleUid: function () {
                return Config.errorsBubbleUidPrefix + this._createUid();
            },

            _createBoxUid: function () {
                return Config.boxUidPrefix + this._createUid();
            },

            _showErrorsBubble: function (e) {
                var bubbleUid = this._createBubbleUid();
                this.bubbles[bubbleUid] = this.uiComponents.host$.createAndRender(bubbleUid, {
                    type: Bubble,
                    options: {
                        targetControl: e.currentTarget,
                        text: this._renderErrorBubbleFragment(e.currentTarget),
                        position: Bubble.POSITION.BOTTOM,
                        showCloseButton: false
                    }
                });
            },

            _hideErrorsBubble: function (e) {
                // clear all bubbles anyways
                _.forOwn(this.bubbles, function (bubble, id) {
                    if (this.uiComponents.hasOwnProperty(id)) {
                        this.uiComponents.host$.hide(id); // first hide it (it takes time for the detach to be painted)
                        this.uiComponents[id].close(); // detach from dom!
                        this.uiComponents.host$.remove(id); // remove from ui components object
                    }
                }, this);
            },

            _renderErrorBubbleFragment: function (targetEl) {
                var tableCellEl = this._findParentTableCellElement(targetEl);
                var errorMessages = this._getErrorMessages(tableCellEl);
                if (!errorMessages) {
                    return '';
                }
                return this._getErrorMessagesFragment(errorMessages);
            },

            _getErrorMessagesFragment: function (errorMessages) {
                var fragment;
                if (errorMessages.length > 1) {
                    fragment = this._getMultipleErrorMessagesFragment(errorMessages);
                } else {
                    fragment = this._getSingleErrorMessageFragment(errorMessages[0]);
                }
                return $('<div>')
                    .addClass(Config.css.errorsBubbleInner)
                    .append(fragment)[0].outerHTML;
            },

            _getSingleErrorMessageFragment: function (errorMessage) {
                return $('<div>').text(errorMessage); // always use .text() and not .html() here to guard from XSS
            },

            _getMultipleErrorMessagesFragment: function (errorMessages) {
                var listEl = $('<ul>');
                _.each(errorMessages, function (val) {
                    listEl.append($('<li>').text(val)); // always use .text() and not .html() here to guard from XSS
                });
                return listEl;
            },

            _getErrorMessages: function (el) {
                var modelAttr = this._getModelAttrByUiBinding(el);
                var errorCodes;
                var errorMessages;

                if (!modelAttr) {
                    return false;
                }
                errorCodes = _.pluck(modelAttr.errors, 'code');
                errorMessages = [];

                if(modelAttr.name === "LOBs"){
                    errorMessages = this._buildLOBErrorText(modelAttr,errorMessages);
                } else if(modelAttr.name === "Skills"){
                    errorMessages = this._buildSkillErrorText(modelAttr,errorMessages);
                } else {
                    _.each(errorCodes, _.bind(function (errorCode) {
                        var errorMessage = this._getErrorMessageByCode(errorCode, modelAttr);
                        if (errorMessage) {
                            errorMessages.push(errorMessage);
                        }
                    }, this));
                }
                return errorMessages;
            },

            _buildLOBErrorText: function (modelAttr, errorMessages) {
                var LOBsErrorType = this._getLOBsErrorByType(modelAttr);
                var errorMessage = "";
                var errorCodes;

                if(!_.isEmpty(LOBsErrorType.LOBNotExistErrorList)){
                    errorMessage = this._getErrorMessageByCode(ERROR_CODE_LOB_NOT_EXIST, modelAttr);
                    errorMessage += _.pluck(LOBsErrorType.LOBNotExistErrorList, 'message').join(',');
                    errorMessages.push(errorMessage);
                }
                if (!_.isEmpty(LOBsErrorType.LOBRemainErrorList)) {
                    errorCodes = _.pluck(LOBsErrorType.LOBRemainErrorList, 'code');
                    _.each(errorCodes, _.bind(function (errorCode) {
                        errorMessage = this._getErrorMessageByCode(errorCode, modelAttr);
                        errorMessages.push(errorMessage);
                    }, this));
                }
                return errorMessages;
            },

            _buildSkillErrorText: function (modelAttr, errorMessages) {
                var skillsErrorType = this._getSkillsErrorByType(modelAttr);
                var errorMessage = "";
                var errorCodes;

                if(!_.isEmpty(skillsErrorType.skillNotExistErrorList)){
                    errorMessage = this._getErrorMessageByCode(ERROR_CODE_SKILL_NOT_EXIST, modelAttr);
                    errorMessage += _.pluck(skillsErrorType.skillNotExistErrorList, 'message').join(',');
                    errorMessages.push(errorMessage);
                }
                if (!_.isEmpty(skillsErrorType.skillRemainErrorList)) {
                    errorCodes = _.pluck(skillsErrorType.skillRemainErrorList, 'code');
                    _.each(errorCodes, _.bind(function (errorCode) {
                        errorMessage = this._getErrorMessageByCode(errorCode, modelAttr);
                        errorMessages.push(errorMessage);
                    }, this));
                }
                return errorMessages;
            },

            _getLOBsErrorByType: function (modelAttr) {
                var LOBNotExistErrorList = [];
                var  LOBRemainErrorList = [];

                _.each(modelAttr.errors, function (error) {
                    if(error.code === ERROR_CODE_LOB_NOT_EXIST){
                        LOBNotExistErrorList.push(error);
                    }else{
                        LOBRemainErrorList.push(error);
                    }
                });

                return {
                    LOBNotExistErrorList : LOBNotExistErrorList,
                    LOBRemainErrorList: LOBRemainErrorList
                };
            },

            _getSkillsErrorByType: function (modelAttr) {
                var skillNotExistErrorList = [];
                var  skillRemainErrorList = [];

                _.each(modelAttr.errors, _.bind(function (error) {
                    if(error.code === ERROR_CODE_SKILL_NOT_EXIST){
                        skillNotExistErrorList.push(error);
                    }else{
                        skillRemainErrorList.push(error);
                    }
                }, this));

                return {
                    skillNotExistErrorList : skillNotExistErrorList,
                    skillRemainErrorList: skillRemainErrorList
                };
            },

            _getErrorMessageByCode: function (errorCode, modelAttr) {
                var messageParam,
                    translationKey,
                    messageArgValues = [];
                if (_.isNaN(errorCode)) {
                    LEContent.logger.graph({name: "content:ContentImportErrorsTableRowView:_getErrorMessageByCode:errorCodeNaN"});
                    LEContent.logger.error('error code is not a number, or is undefined', 'ContentImportErrorsTableRowView:_getErrorMessageByCode', errorCode);
                    return false;
                }
                translationKey = 'LEContent.content.import.serverError.' + errorCode;
                if (LE.translator.hasTranslationKey(LocaleResolver.getDefaultLocale(), translationKey)) {
                    messageParam = {key: translationKey};
                    // some errors require injecting variables into placeholders in the message
                    this._populateErrorMessageFirstArgument(errorCode, messageArgValues, modelAttr);
                    this._populateErrorMessageSecondArgument(errorCode, messageArgValues);
                    if (messageArgValues.length) {
                        messageParam.args = [];
                        _.each(messageArgValues, function (val) {
                            messageParam.args.push({key: val});
                        });
                    }
                    return LE.translator.translate(messageParam);
                }
            },

            _findParentTableCellElement: function (targetEl) {
                var tableCellEl = DomUtilities.findParent(targetEl, 'td');
                if (tableCellEl) {
                    return tableCellEl[0];
                }
            },

            _populateErrorMessageFirstArgument: function (errorCode, messageArgValues, modelAttr) {
                if (_.contains(Config.dynamicErrors.columnName, errorCode)) {
                    messageArgValues.push(modelAttr.name);
                } else if (_.contains(Config.dynamicErrors.value, errorCode)) {
                    messageArgValues.push(modelAttr.value);
                } else if (_.contains(Config.dynamicErrors.categoryMaxCharacters, errorCode)) {
                    messageArgValues.push(this.categoriesValidators.maxNameLength);
                } else if (_.contains(Config.dynamicErrors.categoriesMaxSize, errorCode)) {
                    messageArgValues.push(this.categoriesValidators.maxCategoriesPerAccount);
                }
            },

            _populateErrorMessageSecondArgument: function (errorCode, messageArgValues) {
                if (_.contains(Config.dynamicErrors.titleMaxCharacters, errorCode)) {
                    messageArgValues.push(cannedMessageConfig.maxTitleSize);
                } else if (_.contains(Config.dynamicErrors.textMaxCharacters, errorCode)) {
                    messageArgValues.push(cannedMessageConfig.maxMessageSize);
                }
            },

            _getModelAttrByUiBinding: function (el) {
                if (el === this.ui.itemId[0]) {
                    return this.model.getItemId();
                }
                if (el === this.ui.language[0]) {
                    return this.model.getLanguage();
                }
                if (el === this.ui.title[0]) {
                    return this.model.getTitle();
                }
                if (el === this.ui.text[0]) {
                    return this.model.getText();
                }
                if (el === this.ui.categories[0]) {
                    return this.model.getCategories();
                }
                if (el === this.ui.LOBs[0]) {
                    return this.model.getLOBs();
                }
                if (el === this.ui.skills[0]) {
                    return this.model.getSkills();
                }
                if (el === this.ui.status[0]) {
                    return this.model.getStatus();
                }
                if (el === this.ui.hotKeyLetter[0]) {
                    return this.model.getHotKeyLetter();
                }
                if (el === this.ui.hotKeyNumber[0]) {
                    return this.model.getHotKeyNumber();
                }
            },

            _getLanguagePlusCompositeViewCollection: function () {
                return new PlusCompositeView.DefaultPlusComponentCollection([
                    {
                        name: this.model.getLanguage().value
                    }
                ]);
            },

            _getCategoriesPlusCompositeViewCollection: function () {
                return new PlusCompositeView.DefaultPlusComponentCollection([
                    {
                        name: this.model.getCategories().value
                    }
                ]);
            },

            _getLOBsPlusCompositeViewCollection: function () {
                return new PlusCompositeView.DefaultPlusComponentCollection([
                    {
                        name: this.model.getLOBs().value
                    }
                ]);
            },

            _getSkillsPlusCompositeViewCollection: function () {
                return new PlusCompositeView.DefaultPlusComponentCollection([
                    {
                        name: this.model.getSkills().value
                    }
                ]);
            }

        });

    });

    return ContentImportErrorsTableRowView;
});
